import {debounceTime, takeUntil} from 'rxjs/operators';
import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  OnDestroy, SimpleChanges,
} from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormArray,
  Validators,
  UntypedFormBuilder,
  UntypedFormControl,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import {
  TypesService,
  FormBuilderService,
  ProductService,
  SalesService, NotificationService,
} from '../../../services';
import {
  BorrowerContactModel,
  IndividualSecurityModel,
} from '../../../models/widgets';
import * as _ from 'lodash';
import {BehaviorService} from '../../../services/behavior.service';
import {Subject} from 'rxjs';
import {LCA_ORIGINATOR_PARTY_ROLE_ID} from '../../../_global/wiz.constants';
import {DataHandlerService} from '../../../services/data-handler.service';
import {
  CustomValidator,
  defaultFieldConfig
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/common';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {ValidationPartialComponent} from '../partials';
import {MatInputModule} from '@angular/material/input';
import {MatOptionModule} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {NgFor, NgIf} from '@angular/common';
import {MatCardModule} from '@angular/material/card';
import {
  DateTextComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/date-text/date-text.component';
import {
  AddressSearchComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/address-search/address-search.component';
import {
  CrumbSearchComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/crumb-search/crumb-search.component';
import {
  SensisMobileComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/sensis-mobile/sensis-mobile.component';
import {
  MatInputCommifiedDirective
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/commified/mat-input-commified-directive';
import {
  FurtherAdvanceConfirmationComponent
} from '../further-advance-confirmation/further-advance-confirmation.component';
import {AddressSuggestionsComponent} from '../address-suggestions/address-suggestions.component';

const COMPANY = 'company';
const PERSON = 'person';
const TRUST = 'trust';
const TRUSTEE = 'trustee';
const SECURITY_TRUST = 'security-trust';
const TRUST_WITH_COMPANY = 'trust-with-company';
const TRUST_WITH_INDIVIDUAL = 'trust-with-individual';
const INDIVIDUAL = 'individual';
const INDIVIDUAL_NON_APPLICANT = 'individual-with-non-applicant';
const JOINT_INDIVIDUAL = 'joint-individual';

const PARTY_TYPE_ID = {
  individual: 1,
  company: 2
};

@Component({
    selector: 'app-security-details',
    templateUrl: './security-details.component.html',
    styles: [],
    standalone: true,
  imports: [MatCardModule, MatCardModule, FormsModule, ReactiveFormsModule, NgFor, NgIf, MatCheckboxModule, MatCheckboxModule,
    MatFormFieldModule, MatFormFieldModule, MatSelectModule, MatSelectModule, MatOptionModule,
    MatOptionModule, MatInputModule, MatInputModule, ValidationPartialComponent, MatButtonModule, MatButtonModule,
    MatIconModule, MatProgressSpinnerModule, MatProgressSpinnerModule, MatTooltipModule, DateTextComponent, AddressSearchComponent,
    CrumbSearchComponent, SensisMobileComponent, MatInputCommifiedDirective, FurtherAdvanceConfirmationComponent, AddressSuggestionsComponent]
})
export class SecurityDetailsComponent extends WizardWidgetComponent implements OnInit, OnChanges, OnDestroy {
  @Input() public formGroup: UntypedFormGroup;
  @Input() public applicationType: string;
  @Input() public personList: any;
  @Input() public securityModel: any;
  @Input() public trustList: UntypedFormArray;
  @Input() public companyList: UntypedFormArray;
  @Input() public borrowerType: UntypedFormControl;
  @Input() public isSMSF = false;
  @Input() public faType: string;
  @Input() public isInternalUser = false;
  @Input() public originator: UntypedFormControl;
  @Input() public broker: UntypedFormControl;
  @Input() public isFurtherAdvance = false;
  @Output() public securityDetails = new EventEmitter();
  @Output() public emitTbaAddress = new EventEmitter();

  public valuerAccessBorrowersIsInvalid = false;
  public canSelectValuer = false;
  public securityDataPatched = false;
  public securityFormArray: any;
  public mortgageTypes = [];
  public occupancyTypes = [];
  public securityTypes = [];
  public filteredSecurityTypes = [];
  public securityStatii = [];
  public valuationTypes = [];
  public builderTypes = [];
  public currentUseTypes = [];
  public buildingTypes = [];
  public zoningTypes = [];
  public interestValueTypes = [];
  public valuerContactTypes = [];
  public partyRoleTypes = [];
  public areaTypes = [];
  public phoneTypes = [];
  public valuers = [];
  public realEstatePrs = 'real-estate-agent';
  public availableAddresses = [];
  private areaTypesSlug = 'vx-measurement-types';
  private mortgageTypesSlug = 'collateral-mortgage-types';
  private occupancyTypesSlug = 'collateral-occupancy-types';
  private securityTypesSlug = 'collateral-property-types';
  private securityStatiiSlug = 'collateral-property-status-types';
  private valuationTypesSlug = 'collateral-valuation-types';
  private valuerContactTypesSlug = 'valuer-contact-types';
  private valuationContactTypesSlug = 'valuation-contact-types';
  private partyRoleTypesTypesSlug = 'party-role-types';
  private phoneTypesSlug = 'telephone-types-vx';
  private residentialPropertyTypeClass = 1;
  private onDestroy$ = new Subject();
  public subscriptions = [];

  public acceptedPhoneTypes = {
    'mobile': ['MOBILE']
  };

  // reject mobile numbers
  public rejectedPhoneTypes = {
    'fax': ['MOBILE'],
    'fixed': ['MOBILE'],
  };

  constructor(private typesService: TypesService,
              public dataHandlerService: DataHandlerService,
              private formBuilderService: FormBuilderService,
              private salesService: SalesService,
              private fb: UntypedFormBuilder,
              private productService: ProductService,
              private behaviorService: BehaviorService,
              public notificationService: NotificationService) {
    super(dataHandlerService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.populateTypes().then(() => {
      this.formatValuationContactTypes();
      this.initSecurity();

      if (this.securityModel.securityList && this.securityModel.securityList.value.length && !this.securityDataPatched) {
        this.patchSecurityValues();
      }
    });

    this.securityFormArray = this.formGroup.get('securityList');

    if (this.securityFormArray && this.securityFormArray.value) {
      this.securityDetails.emit(this.securityFormArray.value);
      if (this.securityFormArray.controls.length >= 1) {
        this.securityFormArray.controls = _.map(this.securityFormArray.controls, (ctrl) => this.createIndividualSecurityFormGroup(ctrl.getRawValue()));
      }
    }

    this.behaviorService.rentalInvestmentsUpdated.subscribe((val) => {
      console.debug('SecurityDetailsComponent.behaviorService.rentalInvestmentsUpdated');
      this.updateSecurity(val);
    });

    this.behaviorService.rentalInvestmentRemoved.subscribe((val) => {
      console.debug('SecurityDetailsComponent.behaviorService.rentalInvestmentRemoved');
      const securityIndex = this.securityFormArray.value.findIndex(s => s.link === val);
      if (securityIndex > -1) {
        this.removeSecurity(securityIndex);
      }
    });

    this.onValueChanges();
    this.checkPropertyNotFound();

    this.broker.valueChanges.subscribe((broker) => {
      this.determineIfCanAddValuer(_.get(broker, 'id', null));
    });
    this.determineIfCanAddValuer(this.broker && this.broker.value ? this.broker.value.id : null);

    if (this.isFurtherAdvance && this.faType) {
      this.checkFaFormGroup(this.faType);
    }
  }

  determineIfCanAddValuer(brokerId) {
    if (brokerId) {
      this.salesService.retrieveAdditionals(brokerId).subscribe((val) => {
        this.canSelectValuer = !!val.canAccessValuerList;
      });
    } else {
      this.canSelectValuer = false;
    }
  }

  initializeSecurityFormChanges(formGroup) {
    formGroup.valueChanges
      .pipe(debounceTime(1000), takeUntil(this.onDestroy$))
      .subscribe(() => {
        const rawSecurityValues: any = formGroup.getRawValue();
        this.retrieveValuer(formGroup);
        this.securityDetails.emit(this.securityFormArray.getRawValue());

        console.log('SecurityDetailsComponent.formGroup.valueChanges', formGroup.getRawValue());

        if (rawSecurityValues && rawSecurityValues.valuationType !== 'new-valuation') {
          formGroup.get('valuerAccessBorrower').clearValidators({emitEvent: false});
          formGroup.get('valuerAccessBorrower').updateValueAndValidity({emitEvent: false});
          formGroup.get('valuerAccessOther').clearValidators({emitEvent: false});
          formGroup.get('valuerAccessOther').updateValueAndValidity({emitEvent: false});
        }

        this.checkFaFormGroup(this.faType);
      });

    formGroup.get('valuationType')
      .valueChanges
      .pipe(
        debounceTime(500),
        takeUntil(this.onDestroy$),
      )
      .subscribe((value) => {
        const valexId = formGroup.get('valexId');
        if (value === 'subsidiary-valuation' && !valexId.hasValidator(Validators.required)) {
          valexId.addValidators(Validators.required);
        } else {
          valexId.removeValidators(Validators.required);
        }

        formGroup.updateValueAndValidity();
      });
  }

  retrieveValuer(formGroup) {
    if (this.canSelectValuer) {
      const originator = this.originator.value;
      let entity = 'firstmac';
      if (originator.id === LCA_ORIGINATOR_PARTY_ROLE_ID) {
        entity = 'lca';
      }

      const {securityAddress, estimatedValue, securityType} = formGroup.value;

      if (securityAddress && securityAddress.postcode && estimatedValue) {
        const request = {
          postcode: securityAddress.postcode,
          suburb: securityAddress.suburb,
          estimate: estimatedValue,
          propertyType: securityType,
        };

        const requestParams = JSON.stringify({
          entity,
          request,
        });

        if (requestParams === formGroup.value.valuerParams) {
          console.log('no change in params');
          return;
        }
        formGroup.setControl('valuerLoading', new UntypedFormControl(true));
        formGroup.setControl('valuerParams', new UntypedFormControl(requestParams));
        this.salesService.getValuers(entity, 'full-registered', request).subscribe((val) => {
          formGroup.setControl('valuers', new UntypedFormControl(val));
          formGroup.setControl('valuerLoading', new UntypedFormControl(false));

          const currentValuer = formGroup.value.valuerId;
          const existingMatch = _.find(val, {id: formGroup.value.valuerId});
          if (currentValuer && !existingMatch) {
            formGroup.get('valuerId').patchValue(null);
            formGroup.get('valuerName').patchValue(null);
          }
        });
      }
    }
  }

  setValuerName(idx: number, valuerId: string) {
    const valuer = _.find(this.valuers[idx], {id: valuerId});
    if (!this.securityFormArray.at(idx).get('valuerName')) {
      this.securityFormArray.at(idx).setControl('valuerName', new UntypedFormControl([]));
    }
    this.securityFormArray.at(idx).get('valuerName').patchValue(_.get(valuer, 'name'));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.formGroup && !changes.formGroup.firstChange) {
      if (!(_.isEqual(changes.formGroup.currentValue?.get('securityList'), changes.formGroup.previousValue?.get('securityList')))) {
        this.handleSecurityListChanges(changes.formGroup.currentValue?.get('securityList'));
      }
    }

    if (changes && changes.isSMSF && changes.isSMSF.currentValue !== changes.isSMSF.previousValue && !changes.isSMSF.firstChange) {
      this.initMortgagors();
      this.filterSecurityTypes();
    }

    if (changes && changes.applicationType && changes.applicationType.currentValue !== changes.applicationType.previousValue && !changes.applicationType.firstChange) {
      this.bridgingLoanSetup(changes.applicationType.currentValue);
    }

    if (changes && changes.faType && changes.faType.currentValue) {
      this.checkFaFormGroup(changes.faType.currentValue);
    }
  }

  checkFaFormGroup(faType: string) {
    if (faType === 'existing-security') {
      this.securityFormArray.controls.forEach((securityFormGroup: any) => {
        console.log('checkFaFormGroup - securityFormGroup', securityFormGroup);
        console.log('this.isFurtherAdvance && this.faType', this.isFurtherAdvance && this.faType === 'existing-security');

        // securityFormGroup.get('propertyNotFound').disable({emitEvent: false});

        if (securityFormGroup.get('securityAddress')) {
          securityFormGroup.get('securityAddress').disable({emitEvent: false});
        }

        securityFormGroup.get('valuerAccessBorrower').clearValidators({emitEvent: false});
        securityFormGroup.get('valuerAccessBorrower').updateValueAndValidity({emitEvent: false});
        securityFormGroup.get('valuerAccessOther').clearValidators({emitEvent: false});
        securityFormGroup.get('valuerAccessOther').updateValueAndValidity({emitEvent: false});
      });
    }
  }

  getSecurityAddress(securityFormGroup): string {
    const securityValue = securityFormGroup.getRawValue();
    return (securityValue?.securityAddress?.fullAddress) ? securityValue?.securityAddress?.fullAddress : 'TBA';
  }

  bridgingLoanSetup(applicationType) {
    // ensure there are 2 securities
    if (applicationType === 'new-bridging') {
      if (this.securityFormArray.controls.length === 1) {
        this.addSecurity();
      }

      this.securityFormArray.controls.forEach((formGroup: any) => {
        formGroup.get('occupancy').patchValue('owner-occupied', {emitEvent: false});
      });
    } else {
      if (this.securityFormArray.controls.length > 1) {
        this.securityFormArray.controls.forEach((formGroup: any, index: number) => {
          if (index > 0 && formGroup.pristine) {
            this.securityFormArray.removeAt(index);
          }
        });
      }
    }
  }

  checkPropertyNotFound() {
    this.securityFormArray.controls.forEach((formGroup: any, index: number) => {
      if (formGroup.get('propertyNotFound') && formGroup.get('propertyNotFound').value) {
        this.emitTbaAddress.emit(true);
        this.clearValuationAccessContactDetails(this.securityFormArray.at(index));
      } else {
        this.emitTbaAddress.emit(false);
      }
    });
  }

  onValueChanges() {
    this.borrowerType.valueChanges
      .pipe(debounceTime(500), takeUntil(this.onDestroy$))
      .subscribe(() => this.initMortgagors());
    this.personList.valueChanges
      .pipe(debounceTime(500), takeUntil(this.onDestroy$))
      .subscribe(() => {
        this.initMortgagors();
        this.checkValuationAccessBorrowers();
      });
    this.companyList.valueChanges
      .pipe(debounceTime(500), takeUntil(this.onDestroy$))
      .subscribe(() => this.initMortgagors());
    this.trustList.valueChanges
      .pipe(debounceTime(500), takeUntil(this.onDestroy$))
      .subscribe(() => this.initMortgagors());
  }

  checkValuationAccessBorrowers() {
    this.securityFormArray.controls.forEach((formGroup: any) => {
      this.checkBorrowerContact(formGroup);
    });
  }

  checkBorrowerContact(formGroup) {
    const arrayControl: any = formGroup.get('valuerAccessBorrowers').controls;

    this.personList.getRawValue().forEach((person: any, index: number) => {

      if (!person.nonApplicant) {
        if (formGroup.get('valuerAccessBorrowers').controls.at(index)) {
          formGroup.get('valuerAccessBorrowers').controls.at(index).get('borrowerId').patchValue(index);
          formGroup.get('valuerAccessBorrowers').controls.at(index).get('firstName').patchValue(person.firstName);
          formGroup.get('valuerAccessBorrowers').controls.at(index).get('lastName').patchValue(person.lastName);
          formGroup.get('valuerAccessBorrowers').controls.at(index).get('dateOfBirth').patchValue(person.dateOfBirth);
        } else {
          const borrowerContact = new BorrowerContactModel();
          const fg = this.formBuilderService.convertObjectToFormGroup(borrowerContact);
          this.formBuilderService.setValidationRules(new BorrowerContactModel(), fg);

          fg.get('borrowerId').patchValue(index);
          fg.get('firstName').patchValue(person.firstName);
          fg.get('lastName').patchValue(person.lastName);
          fg.get('dateOfBirth').patchValue(person.dateOfBirth);
          arrayControl.push(fg);
        }
      }
    });
  }

  filterSecurityTypes() {
    const filteredTypes = this.isSMSF ? this.securityTypes : this.securityTypes.filter(x => x.ext['class_id'] === this.residentialPropertyTypeClass);
    this.filteredSecurityTypes = _.sortBy(_.filter(filteredTypes, ['ext.active', true]), 'ext.sort_order');
  }

  populateTypes() {
    return Promise.all([
      this.typesService.getTypesList(this.mortgageTypesSlug).then((results) => {
        this.mortgageTypes = _.sortBy(_.filter(results, ['ext.active', true]), 'ext.sort_order');
      }),
      this.typesService.getTypesList(this.occupancyTypesSlug).then((results) => {
        this.occupancyTypes = _.sortBy(_.filter(results, ['ext.active', true]), 'ext.sort_order');

        if (this.isSMSF) {
          this.occupancyTypes = _.filter(results, ['id', 'investment']);
        }
      }),
      this.typesService.getTypesList(this.securityTypesSlug).then((results) => {
        this.securityTypes = results;
        this.filterSecurityTypes();
      }),
      this.typesService.getTypesList(this.securityStatiiSlug).then((results) => {
        this.securityStatii = _.sortBy(_.filter(results, ['ext.active', true]), 'ext.sort_order');
      }),
      this.typesService.getTypesList(this.valuationTypesSlug).then((results) => {
        const exclude = ['motor-vehicle', 'val-in-hand'];
        const subsidiary: any = results.find(x => x.id === 'subsidiary-valuation');
        subsidiary.text = 'Upfront Valuation';
        this.valuationTypes = results.filter((t) => !exclude.includes(t.id));
      }),
      this.typesService.getTypesList(this.areaTypesSlug).then((results) => {
        this.areaTypes = results;
      }),
      this.typesService.getTypesList(this.valuationContactTypesSlug).then((results) => {
        this.valuerContactTypes = results;
      }),
      this.typesService.getTypesList(this.phoneTypesSlug).then((results) => {
        this.phoneTypes = results;
      }),
      this.typesService.getTypesList(this.partyRoleTypesTypesSlug).then((results) => {
        this.partyRoleTypes = results;
      }),
    ]);
  }

  formatValuationContactTypes() {
    this.valuerContactTypes.forEach((type: any, index: number) => {
      const foundPartyRoleType = this.partyRoleTypes.find(x => x.ext.Slug === type.ext['party_role_slug']);

      if (foundPartyRoleType && foundPartyRoleType.ext.PartyTypeID) {
        type.ext.partyTypeId = foundPartyRoleType.ext.PartyTypeID;
      }
    });
  }

  initSecurity() {
    if (this.securityFormArray.controls.length === 0) {
      console.log('initSecurity - addSecurity');
      this.addSecurity(null);
    }

    // this particular code handles setting the address to person1's residential if primary purpose = refinancing my home
    this.subscriptions.push(
      this.productService.productData.subscribe((val) => {
        if (val && val.input && val.input.primaryPurpose) {
          const primaryPurpose = val.input.primaryPurpose;
          const primaryProperty = this.securityFormArray.at(0);
          if (primaryPurpose === 'refinancing-my-home') {
            // make sure havent found a property checkbox is not applicable
            const b1PrimaryAddress = _.get(this.personList, 'value.0.homeAddress', {});
            if (
              b1PrimaryAddress &&
              b1PrimaryAddress.fullAddress &&
              primaryProperty &&
              primaryProperty.value.securityAddress &&
              !primaryProperty.value.securityAddress.fullAddress
            ) {
              primaryProperty.get('securityAddress').patchValue(b1PrimaryAddress);
            }
            primaryProperty.get('propertyNotFound').disable();
          } else if (
            primaryProperty &&
            primaryProperty.get('propertyNotFound') &&
            primaryProperty.get('propertyNotFound').disabled
          ) {
            primaryProperty.get('propertyNotFound').enable();
          }
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  addSecurity(investment: any = null, addFromUi = false) {
    if (!addFromUi && this.isFurtherAdvance && this.faType && this.faType === 'existing-security') {
      console.log('addSecurity - not from UI and is FA');
      return;
    }

    console.log('add - securityFormGroup', investment);
    const fg = this.formBuilderService.convertObjectToFormGroup(new IndividualSecurityModel());
    if (investment && investment.useAsSecurity && (investment.refinancing || investment.isNewInvestment)) {
      const firstSecurity = this.securityFormArray.at(0);

      if (!firstSecurity.dirty && !firstSecurity.value.useAsSecurity && !this.isFurtherAdvance) {
        this.securityFormArray.removeAt(0);
      }

      fg.get('link').patchValue(investment.link, {emitEvent: false});
      fg.get('useAsSecurity').patchValue(investment.useAsSecurity, {emitEvent: false});
      fg.get('securityAddress').patchValue(investment.securityAddress, {emitEvent: false});
      fg.get('occupancy').patchValue('investment', {emitEvent: false});
      fg.get('securityType').patchValue(investment.propertyType, {emitEvent: false});
      fg.get('estimatedValue').patchValue(investment.assetValue, {emitEvent: false});

      const propertyNotFound = !investment.securityAddress || !investment.securityAddress.country;
      if (investment.useAsSecurity && propertyNotFound) {
        fg.get('propertyNotFound').patchValue(true, {emitEvent: false});
        fg.get('valuationType').patchValue('new-valuation', {emitEvent: false});
      }
    } else if ((investment && !investment.useAsSecurity) || (investment && investment.useAsSecurity && !investment.refinancing && !investment.isNewInvestment)) {
      console.log('addSecurity -> investment [not to be added as security]', investment);
      return;
    }

    this.formBuilderService.setValidationRules(new IndividualSecurityModel(), fg);
    this.initSecurityValues(fg);
    this.securityFormArray.push(fg);
    this.initializeSecurityFormChanges(fg);
    this.checkBorrowerContact(fg);

    console.log('this.applicationType', this.applicationType);
    if (this.applicationType === 'new-bridging') {
      fg.get('occupancy').patchValue('owner-occupied', {emitEvent: false});
    }
  }

  patchSecurityValues() {
    this.securityModel.securityList.value.forEach((securityData: any, index) => {
      console.log('patchSecurityValues', securityData);
      let fg: UntypedFormGroup;
      let pushFormControl = false;
      if (this.securityFormArray.controls.at(index)) {
        fg = this.securityFormArray.controls.at(index);
      } else {
        pushFormControl = true;
        fg = this.formBuilderService.convertObjectToFormGroup(new IndividualSecurityModel());
      }

      if (securityData.securityAddress || fg.get('securityAddress')) {
        if (!securityData.propertyNotFound) {
          fg.addControl('securityAddress', new UntypedFormControl(''), {emitEvent: false});
          fg.get('securityAddress').patchValue(securityData.securityAddress, {emitEvent: false});
        } else {
          this.handleSecurityFound(securityData.propertyNotFound, fg);
        }
      }

      fg.get('link').patchValue(securityData.link, {emitEvent: false});
      fg.get('collateralId').patchValue(securityData.collateralId, {emitEvent: false});
      fg.get('securityId').patchValue(securityData.securityId, {emitEvent: false});
      fg.get('useAsSecurity').patchValue(securityData.useAsSecurity, {emitEvent: false});
      fg.get('occupancy').patchValue(securityData.occupancy, {emitEvent: false});
      fg.get('securityType').patchValue(securityData.securityType, {emitEvent: false});
      fg.get('estimatedValue').patchValue(securityData.estimatedValue, {emitEvent: false});
      fg.get('mortgageType').patchValue(securityData.mortgageType, {emitEvent: false});
      fg.get('securityStatus').patchValue(securityData.securityStatus, {emitEvent: false});
      fg.get('propertyBeingPurchased').patchValue(securityData.propertyBeingPurchased, {emitEvent: false});
      fg.get('contractDate').patchValue(securityData.contractDate, {emitEvent: false});
      fg.get('financeDate').patchValue(securityData.financeDate, {emitEvent: false});
      fg.get('settlementDate').patchValue(securityData.settlementDate, {emitEvent: false});
      fg.get('realEstateAgent').patchValue(securityData.realEstateAgent, {emitEvent: false});
      fg.get('valuationType').patchValue(securityData.valuationType, {emitEvent: false});
      fg.get('valexId').patchValue(securityData.valexId, {emitEvent: false});
      fg.get('inspectionDate').patchValue(securityData.inspectionDate, {emitEvent: false});
      fg.get('accessInstructions').patchValue(securityData.accessInstructions, {emitEvent: false});
      fg.get('valuerId').patchValue(securityData.valuerId, {emitEvent: false});
      fg.get('valuationFirm').patchValue(securityData.valuationFirm, {emitEvent: false});
      fg.get('valuerName').patchValue(securityData.valuerName, {emitEvent: false});
      fg.get('valuerQualifications').patchValue(securityData.valuerQualifications, {emitEvent: false});
      fg.get('currentUse').patchValue(securityData.currentUse, {emitEvent: false});
      fg.get('mainBuilding').patchValue(securityData.mainBuilding, {emitEvent: false});
      fg.get('zoning').patchValue(securityData.zoning, {emitEvent: false});
      fg.get('interestValued').patchValue(securityData.interestValued, {emitEvent: false});
      fg.get('livingArea').patchValue(securityData.livingArea, {emitEvent: false});
      fg.get('livingAreaMeasurement').patchValue(securityData.livingAreaMeasurement, {emitEvent: false});
      fg.get('unitsInDev').patchValue(securityData.unitsInDev, {emitEvent: false});
      fg.get('siteArea').patchValue(securityData.siteArea, {emitEvent: false});
      fg.get('siteAreaMeasurement').patchValue(securityData.siteAreaMeasurement, {emitEvent: false});
      fg.get('valueComponent').patchValue(securityData.valueComponent, {emitEvent: false});
      fg.get('rentalValue').patchValue(securityData.rentalValue, {emitEvent: false});
      fg.get('insuranceValue').patchValue(securityData.insuranceValue, {emitEvent: false});
      fg.get('landValue').patchValue(securityData.landValue, {emitEvent: false});
      fg.get('improvementsValue').patchValue(securityData.improvementsValue, {emitEvent: false});
      fg.get('marketValue').patchValue(securityData.marketValue, {emitEvent: false});
      fg.get('builder').patchValue(securityData.builder, {emitEvent: false});
      fg.get('propertyNotFound').patchValue(securityData.propertyNotFound, {emitEvent: false});

      if (securityData.valuationType !== 'new-valuation') {
        this.clearValuationAccessContactDetails(fg);
      }

      if (pushFormControl) {
        this.formBuilderService.setValidationRules(new IndividualSecurityModel(), fg);
        this.initSecurityValues(fg);
        this.securityFormArray.push(fg);

        console.log('patch - securityFormGroup');

        this.initializeSecurityFormChanges(fg);
      }
    });
  }

  initSecurityValues(fg) {
    const mortgageType: any = _.first(this.mortgageTypes);

    if (mortgageType) {
      fg.get('mortgageType').patchValue(mortgageType.id, {emitEvent: false});
    }

    fg.addControl('mortgagors', this.getMortgagors());
  }

  handleSecurityFound(noSecurity: boolean, security: UntypedFormGroup) {
    if (!noSecurity) {
      security.get('valuationType').patchValue(null);

      // unset address for purposes to TBA
      this.emitTbaAddress.emit(false);
    } else {
      security.removeControl('securityAddress');
      security.get('valuationType').patchValue('new-valuation');

      // set address for purposes to TBA
      this.emitTbaAddress.emit(true);

      this.clearValuationAccessContactDetails(security);
    }
    security.get('valexId').patchValue(null);
    security.get('valuationType').updateValueAndValidity();
  }

  clearValuationAccessContactDetails(formGroup) {
    console.log('clearValuationAccessContactDetails', formGroup);

    const fields: any = [
      'valuerAccessBorrower', 'valuerAccessOther', 'valuerAccessOtherContactType', 'valuerAccessOtherContactName',
      'valuerAccessOtherCompanyName', 'valuerAccessOtherPhoneOneType', 'valuerAccessOtherPhoneOneNumber', 'valuerAccessOtherPhoneTwoType',
      'valuerAccessOtherPhoneTwoNumber'
    ];

    fields.forEach(field => {
      formGroup.get(field).patchValue(null, {emitEvent: null});
      formGroup.get(field).clearValidators();
      formGroup.get(field).updateValueAndValidity();
    });

    formGroup.get('valuerAccessBorrowers').controls.forEach((control: any) => {
      control.get('selected').patchValue(false);
    });
  }

  removeSecurity(index) {
    this.securityFormArray.removeAt(index);
    this.initSecurity();
  }

  updateSecurity(investments: any = null) {
    if (investments) {
      investments.forEach(investment => {
        const {
          link,
          useAsSecurity,
          securityAddress,
          propertyType,
          assetValue,
        } = investment;

        const securityIndex = this.securityFormArray.value.findIndex(s => s.link === link);

        if (securityIndex > -1) {
          if (!useAsSecurity) {
            this.removeSecurity(securityIndex);
          } else {
            const propertyNotFound = !securityAddress || !securityAddress.country || (securityAddress && securityAddress.flatSearch === 'TBA');

            console.log('propertyNotFound', propertyNotFound);
            console.log('securityAddress', securityAddress);
            console.log('securityFormGroup', this.securityFormArray.at(securityIndex));

            if (this.securityFormArray.at(securityIndex).get('securityAddress')) {
              this.securityFormArray.at(securityIndex).get('securityAddress').patchValue(securityAddress);
            }

            this.securityFormArray.at(securityIndex).get('securityType').patchValue(propertyType);
            this.securityFormArray.at(securityIndex).get('estimatedValue').patchValue(assetValue);
            this.securityFormArray.at(securityIndex).get('propertyNotFound').patchValue(propertyNotFound, {emitEvent: false});

            if (propertyNotFound) {
              this.securityFormArray.at(securityIndex).get('propertyNotFound').patchValue(true, {emitEvent: false});
              this.securityFormArray.at(securityIndex).get('valuationType').patchValue('new-valuation', {emitEvent: false});

              this.securityFormArray.at(securityIndex).get('valuerAccessBorrower').clearValidators({emitEvent: false});
              this.securityFormArray.at(securityIndex).get('valuerAccessBorrower').updateValueAndValidity({emitEvent: false});
              this.securityFormArray.at(securityIndex).get('valuerAccessOther').clearValidators({emitEvent: false});
              this.securityFormArray.at(securityIndex).get('valuerAccessOther').updateValueAndValidity({emitEvent: false});
            }


          }
        } else if (useAsSecurity) {
          console.log('updateSecurity - addSecurity(investment)', investment);
          this.addSecurity(investment);
        }
      });
    }
  }

  updateValuation(val, index) {
    if (this.securityFormArray.at(index)) {
      switch (val) {
        case 'new-valuation':
          if (this.securityFormArray.at(index).get('valexId')) {
            this.securityFormArray.at(index).get('valexId').patchValue(null);
          }
          if (this.securityFormArray.at(index).get('valuationFee')) {
            this.securityFormArray.at(index).get('valuationFee').patchValue(null);
          }
          break;
        case 'subsidiary-valuation':
          this.disabledAllValuerAccessFields(this.securityFormArray.at(index));
          if (this.securityFormArray.at(index).get('accessInstructions')) {
            this.securityFormArray.at(index).get('accessInstructions').patchValue(null);
          }
          if (this.securityFormArray.at(index).get('valueComponent')) {
            this.securityFormArray.at(index).get('valueComponent').patchValue('', {emitEvent: false});
          }
          break;
        case 'val-in-hand':
          if (this.securityFormArray.at(index).get('zoning')) {
            this.securityFormArray.at(index).get('zoning').enable();
          }
          break;
      }
    }
  }

  initMortgagors() {
    _.forEach(this.securityFormArray.controls, (securityForm) => {
      securityForm.removeControl('mortgagors');
      securityForm.updateValueAndValidity();
      securityForm.addControl('mortgagors', this.getMortgagors());
    });
  }

  addMortgagor(mortgagors: any) {
    const allBorrowers = [
      ...this.trustList.getRawValue().map((trust, index) => [trust.trustName, TRUST, index]),
      ...this.companyList.getRawValue().map((company, index) => [company.companyName, COMPANY, index]),
      ...this.personList.getRawValue().map((person, index) => [
        this.getMortgagorPersonFullname(person),
        PERSON,
        index,
      ]),
    ];

    const allMortgagors = mortgagors.value;

    const notYetAMortgagor = _.find(allBorrowers, (b) => {
      const [name, type, index] = b;
      return !_.find(allMortgagors, ['to', `${type}-${index}`]);
    });

    if (notYetAMortgagor) {
      const [name, type, index] = notYetAMortgagor;

      if (name && !this.personList.value[index].nonApplicant) {
        const emptyRecordIndex = mortgagors.value.findIndex(x => x.mortgagorName === '');

        if (emptyRecordIndex > -1) {
          mortgagors.controls.at(emptyRecordIndex).get('mortgagorName').patchValue(name);
          mortgagors.controls.at(emptyRecordIndex).get('to').patchValue(`${type}-${index}`);
        } else {
          mortgagors.push(this.newMortgagor(name, type, index));
        }
      } else {
        this.notificationService.toast('warning', 'There are no more borrowers to add to the mortgagors list.', 'Attention');
      }
    } else {
      alert('Please add more borrowers before adding more mortgagors.');
    }
  }

  removeMortgagor(i, mortgagors: UntypedFormArray) {
    mortgagors.removeAt(i);

    if (mortgagors.length === 0) {
      mortgagors.push(this.newMortgagor());
    }
  }

  private getMortgagors(): UntypedFormArray {
    const mortgagors = this.fb.array([]);
    const trustsList = _.chain(this.trustList.value)
      .map((trust, index) => ({...trust, id: index}))
      .compact();
    const trusts = this.isSMSF
      ? trustsList.filter(({trustType}) => trustType === SECURITY_TRUST).value()
      : trustsList.value();

    switch (this.borrowerType.value) {
      case TRUST_WITH_INDIVIDUAL:
        _.forEach(trusts, (trust, index) => {
          const trustees = _.filter(this.personList.getRawValue(), ({companyRelationships}) =>
            _.find(companyRelationships, (rel) => {
              const [destination, i] = _.split(rel.to, '-');
              return index === Number(i) && destination === 'trust' && rel.type === TRUSTEE;
            })
          );

          const foundSecurityTrust = trusts.find(x => x.trustType === 'security-trust');

          let trustee = '';

          if (foundSecurityTrust) {
            const trustIndex = (foundSecurityTrust.contactDetailsAsEntity) ? foundSecurityTrust.contactDetailsAsEntity.split(' ')[0] : 0;

            _.forEach(this.companyList.value, (company, cIndex) => {
              const foundTrust = _.nth(trusts, trustIndex);
              if (foundTrust) {
                const mortgagorName = `${company.companyName || `Company ${cIndex + 1}`
                } as trustee for ${foundTrust.trustName || `Trust ${company.trusteeOf + 1}`}`;
                mortgagors.push(this.newMortgagor(mortgagorName, TRUST, company.trusteeOf));
              }
            });
          } else if (trustees.length > 0) {
            trustees.forEach((person, trusteeIndex) => {
              trustee += `${trusteeIndex === 0 ? '' : ' and'} ${this.getMortgagorPersonFullname(person)}`;
            });

            const mortgagorName = `${trustee || ''} as trustee for ${trust.trustName || `Trust ${index + 1}`
            }`;
            mortgagors.push(this.newMortgagor(mortgagorName, TRUST, index));
          } else {
            // If there's no individual trustees found, refer to company instead
            _.forEach(this.companyList.value, (company, cIndex) => {
              const foundTrust = _.nth(trusts, company.trusteeOf);
              if (foundTrust) {
                const mortgagorName = `${company.companyName || `Company ${cIndex + 1}`
                } as trustee for ${foundTrust.trustName || `Trust ${company.trusteeOf + 1}`}`;
                mortgagors.push(this.newMortgagor(mortgagorName, TRUST, company.trusteeOf));
              }
            });
          }
        });
        break;
      case TRUST_WITH_COMPANY:
        if (this.companyList.value && this.companyList.value.length > 0) {
          _.forEach(this.companyList.value, (company, index) => {
            const trust = _.find(trusts, ({id}) => id === company.trusteeOf);
            if (trust) {
              const mortgagorName = `${company.companyName || `Company ${index + 1}`
              } as trustee for ${trust.trustName || `Trust ${company.trusteeOf + 1}`}`;
              mortgagors.push(this.newMortgagor(mortgagorName, TRUST, company.trusteeOf));
            }
          });
        } else {
          // If there's no company, refer to individuals instead
          _.forEach(trusts, (trust, index) => {
            const trustees = _.filter(this.personList.getRawValue(), ({companyRelationships}) =>
              _.find(companyRelationships, (rel) => {
                const [destination, i] = _.split(rel.to, '-');
                return index === Number(i) && destination === 'trust' && rel.type === TRUSTEE;
              })
            );

            let trustee = '';
            trustees.forEach((person, trusteeIndex) => {
              trustee += `${trusteeIndex === 0 ? '' : ' and'} ${this.getMortgagorPersonFullname(person)}`;
            });

            const mortgagorName = `${trustee || ''} as trustee for ${trust.trustName || `Trust ${index + 1}`
            }`;
            mortgagors.push(this.newMortgagor(mortgagorName, TRUST, index));
          });
        }

        break;
      case COMPANY:
        _.forEach(this.companyList.value, (company, index) => {
          const mortgagorName = company.companyName;
          mortgagors.push(this.newMortgagor(mortgagorName, COMPANY, index));
        });
        break;
      case INDIVIDUAL_NON_APPLICANT:
        _.forEach(this.personList.getRawValue(), (element, index) => {
          if (!element.nonApplicant && element.firstName && element.lastName) {
            const mortgagorName = this.getMortgagorPersonFullname(element);
            mortgagors.push(this.newMortgagor(mortgagorName, PERSON, index));
          }
        });
        break;
      case INDIVIDUAL:
      case JOINT_INDIVIDUAL:
        _.forEach(this.personList.getRawValue(), (element, index) => {
          if (!element.nonApplicant) {
            const mortgagorName = this.getMortgagorPersonFullname(element);
            mortgagors.push(this.newMortgagor(mortgagorName, PERSON, index));
          }
        });
        break;
      default:
        break;
    }
    return mortgagors;
  }

  checkAccessBorrowerValidation(formGroup, value) {
    const arrayControl: any = formGroup.get('valuerAccessBorrowers').controls;
    const rawValues: any = formGroup.getRawValue();
    const foundChecked = _.find(rawValues.valuerAccessBorrowers, {selected: true});

    if (foundChecked) {
      arrayControl.forEach((formControl: any) => {
        formControl.get('selected').clearValidators();
        formControl.get('selected').updateValueAndValidity();
      });
      this.valuerAccessBorrowersIsInvalid = false;
    } else {
      arrayControl.forEach((formControl: any) => {
        formControl.get('selected').setValidators(Validators.required);
        formControl.get('selected').updateValueAndValidity();
      });
      this.valuerAccessBorrowersIsInvalid = true;
    }
  }

  checkPartyType(formGroup, value) {
    const type = this.valuerContactTypes.find(x => x.id === value);

    if (type.ext.partyTypeId === PARTY_TYPE_ID.individual) {
      formGroup.get('valuerAccessOtherCompanyName').disable();
    } else {
      formGroup.get('valuerAccessOtherCompanyName').enable();
    }
  }

  checkValuerContact(formGroup, control, value) {
    if (control === 'valuerAccessBorrower' && value) {
      this.valuerAccessBorrowersIsInvalid = true;

      formGroup.get('valuerAccessOther').patchValue(false);
      formGroup.get('valuerAccessOtherContactType').reset({value: null, disabled: true}, {emitEvent: false});
      formGroup.get('valuerAccessOtherContactName').reset({value: null, disabled: true}, {emitEvent: false});
      formGroup.get('valuerAccessOtherCompanyName').reset({value: null, disabled: true}, {emitEvent: false});
      formGroup.get('valuerAccessOtherPhoneOneType').reset({value: null, disabled: true}, {emitEvent: false});
      formGroup.get('valuerAccessOtherPhoneOneNumber').reset({value: null, disabled: true}, {emitEvent: false});
      formGroup.get('valuerAccessOtherPhoneTwoType').reset({value: null, disabled: true}, {emitEvent: false});
      formGroup.get('valuerAccessOtherPhoneTwoNumber').reset({value: null, disabled: true}, {emitEvent: false});

      const arrayControl: any = formGroup.get('valuerAccessBorrowers').controls;
      arrayControl.forEach((formControl: any) => {
        formControl.get('selected').setValidators(Validators.required);
        formControl.get('selected').updateValueAndValidity();
      });

    } else if (control === 'valuerAccessOther' && value) {
      this.valuerAccessBorrowersIsInvalid = false;

      formGroup.get('valuerAccessOtherContactType').reset({value: null, disabled: false}, {emitEvent: false});
      formGroup.get('valuerAccessOtherContactType').setValidators(Validators.required);
      formGroup.get('valuerAccessOtherContactType').updateValueAndValidity();

      formGroup.get('valuerAccessOtherContactName').reset({value: null, disabled: false}, {emitEvent: false});
      formGroup.get('valuerAccessOtherContactName').setValidators(Validators.compose([Validators.required, CustomValidator.nameValidator(defaultFieldConfig.fullName)]));
      formGroup.get('valuerAccessOtherContactName').updateValueAndValidity();

      formGroup.get('valuerAccessOtherCompanyName').reset({value: null, disabled: false}, {emitEvent: false});
      formGroup.get('valuerAccessOtherPhoneOneType').reset({value: null, disabled: false}, {emitEvent: false});
      formGroup.get('valuerAccessOtherPhoneOneType').setValidators(Validators.required);
      formGroup.get('valuerAccessOtherPhoneOneType').updateValueAndValidity();

      formGroup.get('valuerAccessOtherPhoneOneNumber').reset({value: null, disabled: false}, {emitEvent: false});
      formGroup.get('valuerAccessOtherPhoneOneNumber').setValidators(Validators.required);
      formGroup.get('valuerAccessOtherPhoneOneNumber').updateValueAndValidity();

      formGroup.get('valuerAccessOtherPhoneTwoType').reset({value: null, disabled: false}, {emitEvent: false});
      formGroup.get('valuerAccessOtherPhoneTwoNumber').reset({value: null, disabled: false}, {emitEvent: false});

      formGroup.get('valuerAccessBorrower').patchValue(false);
      const arrayControl: any = formGroup.get('valuerAccessBorrowers').controls;
      arrayControl.forEach((formControl: any) => {
        formControl.get('selected').reset(false, {emitEvent: false});
      });
    }

    if (!formGroup.get('valuerAccessBorrower').value && !formGroup.get('valuerAccessOther').value && formGroup.get('valuationType').value && formGroup.get('valuationType').value === 'new-valuation') {
      formGroup.get('valuerAccessBorrower').patchValue(null);
      formGroup.get('valuerAccessBorrower').setValidators(Validators.required);
      formGroup.get('valuerAccessOther').patchValue(null);
      formGroup.get('valuerAccessOther').setValidators(Validators.required);
    } else if (formGroup.get('valuerAccessBorrower').value || formGroup.get('valuerAccessOther').value) {
      formGroup.get('valuerAccessBorrower').clearValidators();
      formGroup.get('valuerAccessOther').clearValidators();
    }

    formGroup.get('valuerAccessBorrower').updateValueAndValidity();
    formGroup.get('valuerAccessOther').updateValueAndValidity();
  }

  disabledAllValuerAccessFields(formGroup) {
    formGroup.get('valuerAccessOther').reset(false, {emitEvent: false});
    formGroup.get('valuerAccessBorrower').reset(false, {emitEvent: false});
    formGroup.get('valuerAccessOtherContactType').reset({value: null, disabled: true}, {emitEvent: false});
    formGroup.get('valuerAccessOtherContactName').reset({value: null, disabled: true}, {emitEvent: false});
    formGroup.get('valuerAccessOtherCompanyName').reset({value: null, disabled: true}, {emitEvent: false});
    formGroup.get('valuerAccessOtherPhoneOneType').reset({value: null, disabled: true}, {emitEvent: false});
    formGroup.get('valuerAccessOtherPhoneOneNumber').reset({value: null, disabled: true}, {emitEvent: false});
    formGroup.get('valuerAccessOtherPhoneTwoType').reset({value: null, disabled: true}, {emitEvent: false});
    formGroup.get('valuerAccessOtherPhoneTwoNumber').reset({value: null, disabled: true}, {emitEvent: false});

    const arrayControl: any = formGroup.get('valuerAccessBorrowers').controls;
    arrayControl.forEach((formControl: any) => {
      formControl.get('selected').reset(false, {emitEvent: false});
    });
  }

  private newMortgagor(mortgagorName = '', source = '', index = 0): UntypedFormGroup {
    console.log('newMortgagor', mortgagorName);
    return this.fb.group({
      mortgagorName: [mortgagorName || '', Validators.required],
      to: `${source}-${index}`,
    });
  }

  /**
   * get the full name of the mortgagor person
   * @param person
   * @returns
   */
  private getMortgagorPersonFullname(person) {
    // this seems confusing because there is no white space between middlename and lastname is because middlename could
    // be empty and if we put space between it, it will be double whitespace if the middlename is empty,
    // and if not, then the addt space is concatenated in the middlename.
    return `${person.firstName || ''} ${person.middleName ? `${person.middleName} ` : ''}${person.lastName || ''}`;
  }

  private createIndividualSecurityFormGroup(defaultValue: any = null) {
    console.log('create - securityFormGroup', defaultValue);

    const fg = this.formBuilderService.convertObjectToFormGroup(new IndividualSecurityModel());
    if (defaultValue) {
      fg.patchValue(defaultValue);
    }
    this.formBuilderService.setValidationRules(new IndividualSecurityModel(), fg);
    this.initializeSecurityFormChanges(fg as UntypedFormGroup);
    return fg;
  }

  private handleSecurityListChanges(fg: UntypedFormGroup) {
    // if not define yet, it means that `ngOnInit` wasn't ran yet.
    console.log('handleSecurityListChanges', fg);
    if (this.securityFormArray && fg) {
      this.securityFormArray.patchValue(fg.value);
    }
  }
}
